var _path, _circle, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5217 37.3066C19.7353 33.3885 23.6516 30.7559 26.9359 27.6794C30.0525 24.7599 32 20.6074 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 20.6074 1.94745 24.7599 5.06412 27.6794C8.34841 30.7559 12.2647 33.3885 14.4783 37.3066L15.5647 39.2295C15.7561 39.5682 16.2439 39.5682 16.4353 39.2295L17.5217 37.3066Z",
    fill: "#4B4B4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1653_112625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 16,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3636 15.8182C13.5709 15.8182 14.5455 14.8436 14.5455 13.6364C14.5455 12.4291 13.5709 11.4545 12.3636 11.4545C11.1564 11.4545 10.1818 12.4291 10.1818 13.6364C10.1818 14.8436 11.1564 15.8182 12.3636 15.8182ZM21.0909 11.4545H16.7273C15.9273 11.4545 15.2727 12.1091 15.2727 12.9091V16.5455H9.45455V10.7273C9.45455 10.3273 9.12727 10 8.72727 10C8.32727 10 8 10.3273 8 10.7273V20.1818C8 20.5818 8.32727 20.9091 8.72727 20.9091C9.12727 20.9091 9.45455 20.5818 9.45455 20.1818V18.7273H22.5455V20.1818C22.5455 20.5818 22.8727 20.9091 23.2727 20.9091C23.6727 20.9091 24 20.5818 24 20.1818V14.3636C24 12.7564 22.6982 11.4545 21.0909 11.4545Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1653_112625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 24.0649,
    height: 24,
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMarker);
export default __webpack_public_path__ + "static/media/profile-marker.4477cb5f5afeec1ca27ba4cb98a17652.svg";
export { ForwardRef as ReactComponent };